import React from "react";
import { ImgV2 } from "../../../ImgV2";
export const Person = ({ name, position, image }) => (React.createElement("div", { className: "person-root" },
    React.createElement(ImgV2, { src: image }),
    React.createElement("p", { className: "person-root__name" }, name),
    React.createElement("p", { className: "person-root__position" }, position)));
